// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*-----------------------------------*\\
  #RESET
\\*-----------------------------------*/

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a { text-decoration: none; }

li { list-style: none; }

img, ion-icon, a, button, time, span { display: block; }

button {
  font: inherit;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
}

input, textarea {
  display: block;
  width: 100%;
  background: none;
  font: inherit;
}

::selection {
  background: var(--orange-yellow-crayola);
  color: var(--smoky-black);
}

:focus { outline-color: var(--orange-yellow-crayola); }

html { font-family: var(--ff-poppins); }

body { background: var(--smoky-black); }





/*-----------------------------------*\\
  #REUSED STYLE
\\*-----------------------------------*/

.sidebar,
article {
  background: var(--eerie-black-2);
  border: 1px solid var(--jet);
  border-radius: 20px;
  padding: 15px;
  box-shadow: var(--shadow-1);
  z-index: 1;
}

.separator {
  width: 100%;
  height: 1px;
  background: var(--jet);
  margin: 16px 0;
}

.icon-box {
  position: relative;
  background: var(--border-gradient-onyx);
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: var(--orange-yellow-crayola);
  box-shadow: var(--shadow-1);
  z-index: 1;
}

.icon-box::before {
  content: "";
  position: absolute;
  inset: 1px;
  background: var(--eerie-black-1);
  border-radius: inherit;
  z-index: -1;
}

.icon-box ion-icon { --ionicon-stroke-width: 35px; }


article.active {
  display: block;
  animation: fade 0.5s ease backwards;
}

@keyframes fade {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.h2,
.h3,
.h4,
.h5 {
  color: var(--white-2);
  text-transform: capitalize;
}

.h2 { font-size: var(--fs-1); }

.h3 { font-size: var(--fs-2); }

.h4 { font-size: var(--fs-4); }

.h5 {
  font-size: var(--fs-7);
  font-weight: var(--fw-500);
}

.article-title {
  position: relative;
  padding-bottom: 7px;
}

.article-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 3px;
  background: var(--text-gradient-yellow);
  border-radius: 3px;
}

.has-scrollbar::-webkit-scrollbar {
  width: 5px; /* for vertical scrollbar */
  height: 5px; /* for horizontal scrollbar */
}

.has-scrollbar::-webkit-scrollbar-track {
  background: var(--onyx);
  border-radius: 5px;
}

.has-scrollbar::-webkit-scrollbar-thumb {
  background: var(--orange-yellow-crayola);
  border-radius: 5px;
}

.has-scrollbar::-webkit-scrollbar-button { width: 20px; }

.content-card {
  position: relative;
  background: var(--border-gradient-onyx);
  padding: 15px;
  padding-top: 45px;
  border-radius: 14px;
  box-shadow: var(--shadow-2);
  cursor: pointer;
  z-index: 1;
}

.content-card::before {
  content: "";
  position: absolute;
  inset: 1px;
  background: var(--bg-gradient-jet);
  border-radius: inherit;
  z-index: -1;
}





/*-----------------------------------*\\
  #MAIN
\\*-----------------------------------*/

main {
  margin: 15px 12px;
  margin-bottom: 75px;
  min-width: 259px;
}





/*-----------------------------------*\\
  #SIDEBAR
\\*-----------------------------------*/

.sidebar {
  margin-bottom: 15px;
  max-height: 112px;
  overflow: hidden;
  transition: var(--transition-2);
}

.sidebar.active { max-height: 405px; }

.sidebar-info {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
}

.avatar-box {
  background: var(--bg-gradient-onyx);
  border-radius: 20px;
}

.info-content .name {
  color: var(--white-2);
  font-size: var(--fs-3);
  font-weight: var(--fw-500);
  letter-spacing: -0.25px;
  margin-bottom: 10px;
}

.info-content .title {
  color: var(--white-1);
  background: var(--onyx);
  font-size: var(--fs-8);
  font-weight: var(--fw-300);
  width: max-content;
  padding: 3px 12px;
  border-radius: 8px;
}

.info_more-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  border-radius: 0 15px;
  font-size: 13px;
  color: var(--orange-yellow-crayola);
  background: var(--border-gradient-onyx);
  padding: 10px;
  box-shadow: var(--shadow-2);
  transition: var(--transition-1);
  z-index: 1;
}

.info_more-btn::before {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background: var(--bg-gradient-jet);
  transition: var(--transition-1);
  z-index: -1;
}

.info_more-btn:hover,
.info_more-btn:focus { background: var(--bg-gradient-yellow-1); }

.info_more-btn:hover::before,
.info_more-btn:focus::before { background: var(--bg-gradient-yellow-2); }

.info_more-btn span { display: none; }

.sidebar-info_more {
  opacity: 0;
  visibility: hidden;
  transition: var(--transition-2);
}

.sidebar.active .sidebar-info_more {
  opacity: 1;
  visibility: visible;
}

.contacts-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.contact-item {
  min-width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-info {
  max-width: calc(100% - 46px);
  width: calc(100% - 46px);
}

.contact-title {
  color: var(--light-gray-70);
  font-size: var(--fs-8);
  text-transform: uppercase;
  margin-bottom: 2px;
}

.contact-info :is(.contact-link, time, address) {
  color: var(--white-2);
  font-size: var(--fs-7);
}

.contact-info address { font-style: normal; }

.social-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  padding-bottom: 4px;
  padding-left: 7px;
}

.social-item .social-link {
  color: var(--light-gray-70);
  font-size: 18px;
}


.social-item .social-link:hover { color: var(--light-gray); }





/*-----------------------------------*\\
  #NAVBAR
\\*-----------------------------------*/

.navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: hsla(240, 1%, 17%, 0.75);
  backdrop-filter: blur(10px);
  border: 1px solid var(--jet);
  border-radius: 12px 12px 0 0;
  box-shadow: var(--shadow-2);
  z-index: 5;
}

.navbar-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
}

.navbar-link {
  color: var(--light-gray);
  font-size: var(--fs-8);
  padding: 20px 7px;
  transition: color var(--transition-1);
}

.navbar-link:hover,
.navbar-link:focus { color: var(--light-gray-70); }

.navbar-link.active { color: var(--orange-yellow-crayola); }





/*-----------------------------------*\\
  #ABOUT
\\*-----------------------------------*/

.about .article-title { margin-bottom: 15px; }

.about-text {
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
  line-height: 1.6;
}

.about-text p { margin-bottom: 15px; }



/**
 * #service 
 */

.service { margin-bottom: 35px; }

.service-title { margin-bottom: 20px; }

.service-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.service-item {
  position: relative;
  background: var(--border-gradient-onyx);
  padding: 20px;
  border-radius: 14px;
  box-shadow: var(--shadow-2);
  z-index: 1;
}

.service-item::before {
  content: "";
  position: absolute;
  inset: 1px;
  background: var(--bg-gradient-jet);
  border-radius: inherit;
  z-index: -1;
}

.service-icon-box { margin-bottom: 10px; }

.service-icon-box img { margin: auto; }

.service-content-box { text-align: center; }

.service-item-title { margin-bottom: 7px; }

.service-item-text {
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-3);
  line-height: 1.6;
}


/**
 * #testimonials 
 */

.testimonials { margin-bottom: 30px; }

.testimonials-title { margin-bottom: 20px; }

.testimonials-list {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  margin: 0 -15px;
  padding: 25px 15px;
  padding-bottom: 35px;
  overflow-x: auto;
  scroll-behavior: smooth;
  overscroll-behavior-inline: contain;
  scroll-snap-type: inline mandatory;
}

.testimonials-item {
  min-width: 100%;
  scroll-snap-align: center;
}

.testimonials-avatar-box {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(15px, -25px);
  background: var(--bg-gradient-onyx);
  border-radius: 14px;
  box-shadow: var(--shadow-1);
}

.testimonials-item-title { margin-bottom: 7px; }

.testimonials-text {
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
  line-height: 1.6;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}


/**
 * #testimonials-modal
 */

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 20;
  pointer-events: none;
  visibility: hidden;
}

.modal-container::-webkit-scrollbar { display: none; }

.modal-container.active {
  pointer-events: all;
  visibility: visible;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: hsl(0, 0%, 5%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 1;
  transition: var(--transition-1);
}

.overlay.active {
  opacity: 0.8;
  visibility: visible;
  pointer-events: all;
}

.testimonials-modal {
  background: var(--eerie-black-2);
  position: relative;
  padding: 15px;
  margin: 15px 12px;
  border: 1px solid var(--jet);
  border-radius: 14px;
  box-shadow: var(--shadow-5);
  transform: scale(1.2);
  opacity: 0;
  transition: var(--transition-1);
  z-index: 2;
}

.modal-container.active .testimonials-modal {
  transform: scale(1);
  opacity: 1;
}

.modal-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: var(--onyx);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white-2);
  font-size: 18px;
  opacity: 0.7;
}

.modal-close-btn:hover,
.modal-close-btn:focus { opacity: 1; }

.modal-close-btn ion-icon { --ionicon-stroke-width: 50px; }

.modal-avatar-box {
  background: var(--bg-gradient-onyx);
  width: max-content;
  border-radius: 14px;
  margin-bottom: 15px;
  box-shadow: var(--shadow-2);
}

.modal-img-wrapper > img { display: none; }

.modal-title { margin-bottom: 4px; }

.modal-content time {
  font-size: var(--fs-6);
  color: var(--light-gray-70);
  font-weight: var(--fw-300);
  margin-bottom: 10px;
}

.modal-content p {
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
  line-height: 1.6;
}


/**
 * #clients 
 */

.clients { margin-bottom: 15px; }

.clients-list {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  margin: 0 -15px;
  padding: 25px;
  padding-bottom: 25px;
  overflow-x: auto;
  scroll-behavior: smooth;
  overscroll-behavior-inline: contain;
  scroll-snap-type: inline mandatory;
  scroll-padding-inline: 25px;
}

.clients-item {
  min-width: 50%;
  scroll-snap-align: start;
}

.clients-item img {
  width: 100%;
  filter: grayscale(1);
  transition: var(--transition-1);
}

.clients-item img:hover { filter: grayscale(0); }





/*-----------------------------------*\\
  #RESUME
\\*-----------------------------------*/

.article-title { margin-bottom: 30px; }


/**
 * education and experience 
 */

.timeline { margin-bottom: 30px; }

.timeline .title-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
}

.timeline-list {
  font-size: var(--fs-6);
  margin-left: 45px;
}

.timeline-item { position: relative; }

.timeline-item:not(:last-child) { margin-bottom: 20px; }

.timeline-item-title {
  font-size: var(--fs-6);
  line-height: 1.3;
  margin-bottom: 7px;
}

.timeline-list span {
  color: var(--vegas-gold);
  font-weight: var(--fw-400);
  line-height: 1.6;
}

.timeline-item:not(:last-child)::before {
  content: "";
  position: absolute;
  top: -25px;
  left: -30px;
  width: 1px;
  height: calc(100% + 50px);
  background: var(--jet);
}

.timeline-item::after {
  content: "";
  position: absolute;
  top: 5px;
  left: -33px;
  height: 6px;
  width: 6px;
  background: var(--text-gradient-yellow);
  border-radius: 50%;
  box-shadow: 0 0 0 4px var(--jet);
}

.timeline-text {
  color: var(--light-gray);
  font-weight: var(--fw-300);
  line-height: 1.6;
}


/**
 * skills 
 */

.skills-title { margin-bottom: 20px; }

.skills-list { padding: 20px; }


.skills-item:not(:last-child) { margin-bottom: 15px; }

.skill .title-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}

.skill .title-wrapper data {
  color: var(--light-gray);
  font-size: var(--fs-7);
  font-weight: var(--fw-300);
}

.skill-progress-bg {
  background: var(--jet);
  width: 100%;
  height: 8px;
  border-radius: 10px;
}

.skill-progress-fill {
  background: var(--text-gradient-yellow);
  height: 100%;
  border-radius: inherit;
}





/*-----------------------------------*\\
  #PORTFOLIO
\\*-----------------------------------*/

.filter-list { display: none; }

.filter-select-box {
  position: relative;
  margin-bottom: 25px;
}

.filter-select {
  background: var(--eerie-black-2);
  color: var(--light-gray);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--jet);
  border-radius: 14px;
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
}

.filter-select.active .select-icon { transform: rotate(0.5turn); }

.select-list {
  background: var(--eerie-black-2);
  position: absolute;
  top: calc(100% + 6px);
  width: 100%;
  padding: 6px;
  border: 1px solid var(--jet);
  border-radius: 14px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: 0.15s ease-in-out;
}

.filter-select.active + .select-list {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}

.select-item button {
  background: var(--eerie-black-2);
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
  text-transform: capitalize;
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
}

.select-item button:hover { --eerie-black-2: hsl(240, 2%, 20%); }

.project-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 10px;
}

.project-item { display: none; }

.project-item.active {
  display: block;
  animation: scaleUp 0.25s ease forwards;
}

@keyframes scaleUp {
  0% { transform: scale(0.5); }
  100% { transform: scale(1); }
}

.project-item > a { width: 100%; }

.project-img {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 15px;
}

.project-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
  transition: var(--transition-1);
}

.project-item > a:hover .project-img::before { background: hsla(0, 0%, 0%, 0.5); }

.project-item-icon-box {
  --scale: 0.8;

  background: var(--jet);
  color: var(--orange-yellow-crayola);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale));
  font-size: 20px;
  padding: 18px;
  border-radius: 12px;
  opacity: 0;
  z-index: 1;
  transition: var(--transition-1);
}

.project-item > a:hover .project-item-icon-box {
  --scale: 1;
  opacity: 1;
}

.project-item-icon-box ion-icon { --ionicon-stroke-width: 50px; }

.project-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition-1);
}

.project-item > a:hover img { transform: scale(1.1); }

.project-title,
.project-category { margin-left: 10px; }

.project-title {
  color: var(--white-2);
  font-size: var(--fs-5);
  font-weight: var(--fw-400);
  text-transform: capitalize;
  line-height: 1.3;
}

.project-category {
  color: var(--light-gray-70);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
}





/*-----------------------------------*\\
  #BLOG
\\*-----------------------------------*/

.blog-posts { margin-bottom: 10px; }

.blog-posts-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.blog-post-item > a {
  position: relative;
  background: var(--border-gradient-onyx);
  height: 100%;
  box-shadow: var(--shadow-4);
  border-radius: 16px;
  z-index: 1;
}

.blog-post-item > a::before {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background: var(--eerie-black-1);
  z-index: -1;
}

.blog-banner-box {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
}

.blog-banner-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition-1);
}

.blog-post-item > a:hover .blog-banner-box img { transform: scale(1.1); }

.blog-content { padding: 15px; }

.blog-meta {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
}

.blog-meta :is(.blog-category, time) {
  color: var(--light-gray-70);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
}

.blog-meta .dot {
  background: var(--light-gray-70);
  width: 4px;
  height: 4px;
  border-radius: 4px;
}

.blog-item-title {
  margin-bottom: 10px;
  line-height: 1.3;
  transition: var(--transition-1);
}

.blog-post-item > a:hover .blog-item-title { color: var(--orange-yellow-crayola); }

.blog-text {
  color: var(--light-gray);
  font-size: var(--fs-6);
  font-weight: var(--fw-300);
  line-height: 1.6;
}





/*-----------------------------------*\\
  #CONTACT
\\*-----------------------------------*/

.mapbox {
  position: relative;
  height: 250px;
  width: 100%;
  border-radius: 16px;
  margin-bottom: 30px;
  border: 1px solid var(--jet);
  overflow: hidden;
}

.mapbox figure { height: 100%; }

.mapbox iframe {
  width: 100%;
  height: 100%;
  border: none;
  filter: grayscale(1) invert(1);
}

.contact-form { margin-bottom: 10px; }

.form-title { margin-bottom: 20px; }

.input-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 25px;
  margin-bottom: 25px;
}

.form-input {
  color: var(--white-2);
  font-size: var(--fs-6);
  font-weight: var(--fw-400);
  padding: 13px 20px;
  border: 1px solid var(--jet);
  border-radius: 14px;
  outline: none;
}

.form-input::placeholder { font-weight: var(--fw-500); }

.form-input:focus { border-color: var(--orange-yellow-crayola); }

textarea.form-input {
  min-height: 100px;
  height: 120px;
  max-height: 200px;
  resize: vertical;
  margin-bottom: 25px;
}

textarea.form-input::-webkit-resizer { display: none; }

.form-input:focus:invalid { border-color: var(--bittersweet-shimmer); }

.form-btn {
  position: relative;
  width: 100%;
  background: var(--border-gradient-onyx);
  color: var(--orange-yellow-crayola);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 13px 20px;
  border-radius: 14px;
  font-size: var(--fs-6);
  text-transform: capitalize;
  box-shadow: var(--shadow-3);
  z-index: 1;
  transition: var(--transition-1);
}

.form-btn::before {
  content: "";
  position: absolute;
  inset: 1px;
  background: var(--bg-gradient-jet);
  border-radius: inherit;
  z-index: -1;
  transition: var(--transition-1);
}

.form-btn ion-icon { font-size: 16px; }

.form-btn:hover { background: var(--bg-gradient-yellow-1); }

.form-btn:hover::before { background: var(--bg-gradient-yellow-2); }

.form-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-btn:disabled:hover { background: var(--border-gradient-onyx); }

.form-btn:disabled:hover::before { background: var(--bg-gradient-jet); }





/*-----------------------------------*\\
  #RESPONSIVE
\\*-----------------------------------*/

/**
 * responsive larger than 450px screen
 */

@media (min-width: 450px) {

  /**
   * client
   */

  .clients-item { min-width: calc(33.33% - 10px); }



  /**
   * #PORTFOLIO, BLOG 
   */

  .project-img,
  .blog-banner-box { height: auto; }

}





/**
 * responsive larger than 580px screen
 */

@media (min-width: 580px) {

  /**
   * CUSTOM PROPERTY
   */

  :root {

    /**
     * typography
     */

    --fs-1: 32px;
    --fs-2: 24px;
    --fs-3: 26px;
    --fs-4: 18px;
    --fs-6: 15px;
    --fs-7: 15px;
    --fs-8: 12px;

  }



  /**
   * #REUSED STYLE
   */

  .sidebar, article {
    width: 520px;
    margin-inline: auto;
    padding: 30px;
  }

  .article-title {
    font-weight: var(--fw-600);
    padding-bottom: 15px;
  }

  .article-title::after {
    width: 40px;
    height: 5px;
  }

  .icon-box {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    font-size: 18px;
  }



  /**
   * #MAIN
   */

  main {
    margin-top: 60px;
    margin-bottom: 100px;
  }



  /**
   * #SIDEBAR
   */

  .sidebar {
    max-height: 180px;
    margin-bottom: 30px;
  }

  .sidebar.active { max-height: 584px; }

  .sidebar-info { gap: 25px; }

  .avatar-box { border-radius: 30px; }

  .avatar-box img { width: 120px; }

  .info-content .name { margin-bottom: 15px; }

  .info-content .title { padding: 5px 18px; }

  .info_more-btn {
    top: -30px;
    right: -30px;
    padding: 10px 15px;
  }

  .info_more-btn span {
    display: block;
    font-size: var(--fs-8);
  }

  .info_more-btn ion-icon { display: none; }

  .separator { margin: 32px 0; }

  .contacts-list { gap: 20px; }

  .contact-info {
    max-width: calc(100% - 64px);
    width: calc(100% - 64px);
  }



  /**
   * #NAVBAR
   */

  .navbar { border-radius: 20px 20px 0 0; }

  .navbar-list { gap: 20px; }

  .navbar-link { --fs-8: 14px; }



  /**
   * #ABOUT
   */

  .about .article-title { margin-bottom: 20px; }

  .about-text { margin-bottom: 40px; }

  /* service */

  .service-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 18px;
    padding: 30px;
  }

  .service-icon-box {
    margin-bottom: 0;
    margin-top: 5px;
  }

  .service-content-box { text-align: left; }

  /* testimonials */

  .testimonials-title { margin-bottom: 25px; }

  .testimonials-list {
    gap: 30px;
    margin: 0 -30px;
    padding: 30px;
    padding-bottom: 35px;
  }

  .content-card {
    padding: 30px;
    padding-top: 25px;
  }

  .testimonials-avatar-box {
    transform: translate(30px, -30px);
    border-radius: 20px;
  }

  .testimonials-avatar-box img { width: 80px; }

  .testimonials-item-title {
    margin-bottom: 10px;
    margin-left: 95px;
  }

  .testimonials-text {
    line-clamp: 2;
    -webkit-line-clamp: 2;
  }

  /* testimonials modal */

  .modal-container { padding: 20px; }

  .testimonials-modal {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    gap: 25px;
    padding: 30px;
    border-radius: 20px;
  }

  .modal-img-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-avatar-box {
    border-radius: 18px;
    margin-bottom: 0;
  }

  .modal-avatar-box img { width: 65px; }

  .modal-img-wrapper > img {
    display: block;
    flex-grow: 1;
    width: 35px;
  }

  /* clients */

  .clients-list {
    gap: 50px;
    margin: 0 -30px;
    padding: 45px;
    scroll-padding-inline: 45px;
  }

  .clients-item { min-width: calc(33.33% - 35px); }



  /**
   * #RESUME
   */

  .timeline-list { margin-left: 65px; }

  .timeline-item:not(:last-child)::before { left: -40px; }

  .timeline-item::after {
    height: 8px;
    width: 8px;
    left: -43px;
  }

  .skills-item:not(:last-child) { margin-bottom: 25px; }



  /**
   * #PORTFOLIO, BLOG
   */

  .project-img, .blog-banner-box { border-radius: 16px; }

  .blog-posts-list { gap: 30px; }

  .blog-content { padding: 25px; }



  /**
   * #CONTACT
   */

  .mapbox {
    height: 380px;
    border-radius: 18px;
  }

  .input-wrapper {
    gap: 30px;
    margin-bottom: 30px;
  }

  .form-input { padding: 15px 20px; }

  textarea.form-input { margin-bottom: 30px; }

  .form-btn {
    --fs-6: 16px;
    padding: 16px 20px;
  }

  .form-btn ion-icon { font-size: 18px; }

}





/**
 * responsive larger than 768px screen
 */

@media (min-width: 768px) {

  /**
   * REUSED STYLE
   */

  .sidebar, article { width: 700px; }

  .has-scrollbar::-webkit-scrollbar-button { width: 100px; }



  /**
   * SIDEBAR
   */

  .contacts-list {
    grid-template-columns: 1fr 1fr;
    gap: 30px 15px;
  }



  /**
   * NAVBAR
   */

  .navbar-link { --fs-8: 15px; }



  /**
   * ABOUT
   */

  /* testimonials modal */

  .testimonials-modal {
    gap: 35px;
    max-width: 680px;
  }

  .modal-avatar-box img { width: 80px; }



  /**
   * PORTFOLIO
   */

  .article-title { padding-bottom: 20px; }

  .filter-select-box { display: none; }

  .filter-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 25px;
    padding-left: 5px;
    margin-bottom: 30px;
  }

  .filter-item button {
    color: var(--light-gray);
    font-size: var(--fs-5);
    transition: var(--transition-1);
  }

  .filter-item button:hover { color: var(--light-gray-70); }

  .filter-item button.active { color: var(--orange-yellow-crayola); }

  /* portfolio and blog grid */

  .project-list, .blog-posts-list { grid-template-columns: 1fr 1fr; }



  /**
   * CONTACT
   */

  .input-wrapper { grid-template-columns: 1fr 1fr; }

  .form-btn {
    width: max-content;
    margin-left: auto;
  }
  
}





/**
 * responsive larger than 1024px screen
 */

@media (min-width: 1024px) {

  /**
   * CUSTOM PROPERTY
   */

  :root {

    /**
    * shadow
    */

    --shadow-1: -4px 8px 24px hsla(0, 0%, 0%, 0.125);
    --shadow-2: 0 16px 30px hsla(0, 0%, 0%, 0.125);
    --shadow-3: 0 16px 40px hsla(0, 0%, 0%, 0.125);

  }



  /**
   * REUSED STYLE
   */

  .sidebar, article {
    width: 950px;
    box-shadow: var(--shadow-5);
  }



  /**
   * MAIN 
   */

  main { margin-bottom: 60px; }

  .main-content {
    position: relative;
    width: max-content;
    margin: auto;
  }



  /**
   * NAVBAR
   */

  .navbar {
    position: absolute;
    bottom: auto;
    top: 0;
    left: auto;
    right: 0;
    width: max-content;
    border-radius: 0 20px;
    padding: 0 20px;
    box-shadow: none;
  }

  .navbar-list {
    gap: 30px;
    padding: 0 20px;
  }

  .navbar-link { font-weight: var(--fw-500); }



  /**
   * ABOUT
   */

  /* service */

  .service-list {
    grid-template-columns: 1fr 1fr;
    gap: 20px 25px;
  }

  /* testimonials */

  .testimonials-item { min-width: calc(50% - 15px); }

  /* clients */

  .clients-item { min-width: calc(25% - 38px); }



  /**
   * PORTFOLIO
   */

  .project-list { grid-template-columns: repeat(3, 1fr); }



  /**
   * BLOG
   */

  .blog-banner-box { height: 230px; }

}





/**
 * responsive larger than 1250px screen
 */

@media (min-width: 1250px) {

  /**
   * RESET
   */

  body::-webkit-scrollbar { width: 20px; }

  body::-webkit-scrollbar-track { background: var(--smoky-black); }

  body::-webkit-scrollbar-thumb {
    border: 5px solid var(--smoky-black);
    background: hsla(0, 0%, 100%, 0.1);
    border-radius: 20px;
    box-shadow: inset 1px 1px 0 hsla(0, 0%, 100%, 0.11),
                inset -1px -1px 0 hsla(0, 0%, 100%, 0.11);
  }

  body::-webkit-scrollbar-thumb:hover { background: hsla(0, 0%, 100%, 0.15); }

  body::-webkit-scrollbar-button { height: 60px; }



  /**
   * REUSED STYLE
   */

  .sidebar, article { width: auto; }

  article { min-height: 100%; }



  /**
   * MAIN
   */

  main {
    max-width: 1200px;
    margin-inline: auto;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 25px;
  }

  .main-content {
    min-width: 75%;
    width: 75%;
    margin: 0;
  }



  /**
   * SIDEBAR
   */

  .sidebar {
    position: sticky;
    top: 60px;
    max-height: max-content;
    height: 100%;
    margin-bottom: 0;
    padding-top: 60px;
    z-index: 1;
  }

  .sidebar-info { flex-direction: column; }

  .avatar-box img { width: 150px; }

  .info-content .name {
    white-space: nowrap;
    text-align: center;
  }

  .info-content .title { margin: auto; }

  .info_more-btn { display: none; }

  .sidebar-info_more {
    opacity: 1;
    visibility: visible;
  }

  .contacts-list { grid-template-columns: 1fr; }

  .contact-info :is(.contact-link) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contact-info :is(.contact-link, time, address) {
    --fs-7: 14px;
    font-weight: var(--fw-300);
  }

  .separator:last-of-type {
    margin: 15px 0;
    opacity: 0;
  }

  .social-list { justify-content: center; }



  /**
	 * RESUME
	 */

  .timeline-text { max-width: 700px; }

}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;;sCAEsC;;AAEtC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,IAAI,qBAAqB,EAAE;;AAE3B,KAAK,gBAAgB,EAAE;;AAEvB,uCAAuC,cAAc,EAAE;;AAEvD;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,SAAS,2CAA2C,EAAE;;AAEtD,OAAO,8BAA8B,EAAE;;AAEvC,OAAO,8BAA8B,EAAE;;;;;;AAMvC;;sCAEsC;;AAEtC;;EAEE,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;AACb;;AAEA,qBAAqB,4BAA4B,EAAE;;;AAGnD;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;;;;EAIE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,MAAM,sBAAsB,EAAE;;AAE9B,MAAM,sBAAsB,EAAE;;AAE9B,MAAM,sBAAsB,EAAE;;AAE9B;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,WAAW,EAAE,6BAA6B;AAC5C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,2CAA2C,WAAW,EAAE;;AAExD;EACE,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;AACb;;;;;;AAMA;;sCAEsC;;AAEtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;;;;;AAMA;;sCAEsC;;AAEtC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,kBAAkB,iBAAiB,EAAE;;AAErC;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mCAAmC;EACnC,uCAAuC;EACvC,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;uBACuB,uCAAuC,EAAE;;AAEhE;+BAC+B,uCAAuC,EAAE;;AAExE,sBAAsB,aAAa,EAAE;;AAErC;EACE,UAAU;EACV,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wBAAwB,kBAAkB,EAAE;;AAE5C;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;;AAGA,kCAAkC,wBAAwB,EAAE;;;;;;AAM5D;;sCAEsC;;AAEtC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;qBACqB,2BAA2B,EAAE;;AAElD,sBAAsB,mCAAmC,EAAE;;;;;;AAM3D;;sCAEsC;;AAEtC,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,gBAAgB,mBAAmB,EAAE;;;;AAIrC;;EAEE;;AAEF,WAAW,mBAAmB,EAAE;;AAEhC,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;AACb;;AAEA,oBAAoB,mBAAmB,EAAE;;AAEzC,wBAAwB,YAAY,EAAE;;AAEtC,uBAAuB,kBAAkB,EAAE;;AAE3C,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF,gBAAgB,mBAAmB,EAAE;;AAErC,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B,kBAAkB,EAAE;;AAE/C;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,sCAAsC,aAAa,EAAE;;AAErD;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;EACV,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;yBACyB,UAAU,EAAE;;AAErC,4BAA4B,4BAA4B,EAAE;;AAE1D;EACE,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B,aAAa,EAAE;;AAE1C,eAAe,kBAAkB,EAAE;;AAEnC;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF,WAAW,mBAAmB,EAAE;;AAEhC;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,0BAA0B,oBAAoB,EAAE;;;;;;AAMhD;;sCAEsC;;AAEtC,iBAAiB,mBAAmB,EAAE;;;AAGtC;;EAEE;;AAEF,YAAY,mBAAmB,EAAE;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iBAAiB,kBAAkB,EAAE;;AAErC,kCAAkC,mBAAmB,EAAE;;AAEvD;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,UAAU;EACV,uCAAuC;EACvC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF,gBAAgB,mBAAmB,EAAE;;AAErC,eAAe,aAAa,EAAE;;;AAG9B,gCAAgC,mBAAmB,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,sBAAsB;AACxB;;;;;;AAMA;;sCAEsC;;AAEtC,eAAe,aAAa,EAAE;;AAE9B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,qCAAqC,0BAA0B,EAAE;;AAEjE;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,4BAA4B,kCAAkC,EAAE;;AAEhE;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB,aAAa,EAAE;;AAE/B;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,KAAK,qBAAqB,EAAE;EAC5B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,+BAA+B;AACjC;;AAEA,+CAA+C,gCAAgC,EAAE;;AAEjF;EACE,YAAY;;EAEZ,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oDAAoD;EACpD,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA,kCAAkC,4BAA4B,EAAE;;AAEhE;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,8BAA8B,qBAAqB,EAAE;;AAErD;oBACoB,iBAAiB,EAAE;;AAEvC;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B;;;;;;AAMA;;sCAEsC;;AAEtC,cAAc,mBAAmB,EAAE;;AAEnC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,iDAAiD,qBAAqB,EAAE;;AAExE,gBAAgB,aAAa,EAAE;;AAE/B;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,6CAA6C,mCAAmC,EAAE;;AAElF;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;;;;;AAMA;;sCAEsC;;AAEtC;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB,YAAY,EAAE;;AAE/B;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;AAChC;;AAEA,gBAAgB,mBAAmB,EAAE;;AAErC,cAAc,mBAAmB,EAAE;;AAEnC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;AACf;;AAEA,2BAA2B,0BAA0B,EAAE;;AAEvD,oBAAoB,0CAA0C,EAAE;;AAEhE;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uCAAuC,aAAa,EAAE;;AAEtD,4BAA4B,wCAAwC,EAAE;;AAEtE;EACE,kBAAkB;EAClB,WAAW;EACX,uCAAuC;EACvC,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;EACX,+BAA+B;AACjC;;AAEA,qBAAqB,eAAe,EAAE;;AAEtC,kBAAkB,uCAAuC,EAAE;;AAE3D,0BAA0B,uCAAuC,EAAE;;AAEnE;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B,uCAAuC,EAAE;;AAEpE,mCAAmC,kCAAkC,EAAE;;;;;;AAMvE;;sCAEsC;;AAEtC;;EAEE;;AAEF;;EAEE;;IAEE;;EAEF,gBAAgB,8BAA8B,EAAE;;;;EAIhD;;IAEE;;EAEF;qBACmB,YAAY,EAAE;;AAEnC;;;;;;AAMA;;EAEE;;AAEF;;EAEE;;IAEE;;EAEF;;IAEE;;MAEE;;IAEF,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;;EAEd;;;;EAIA;;IAEE;;EAEF;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;;;EAIA;;IAEE;;EAEF;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;;;EAIA;;IAEE;;EAEF;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,kBAAkB,iBAAiB,EAAE;;EAErC,gBAAgB,SAAS,EAAE;;EAE3B,cAAc,mBAAmB,EAAE;;EAEnC,kBAAkB,YAAY,EAAE;;EAEhC,sBAAsB,mBAAmB,EAAE;;EAE3C,uBAAuB,iBAAiB,EAAE;;EAE1C;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA,0BAA0B,aAAa,EAAE;;EAEzC,aAAa,cAAc,EAAE;;EAE7B,iBAAiB,SAAS,EAAE;;EAE5B;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;;;EAIA;;IAEE;;EAEF,UAAU,4BAA4B,EAAE;;EAExC,eAAe,SAAS,EAAE;;EAE1B,eAAe,YAAY,EAAE;;;;EAI7B;;IAEE;;EAEF,wBAAwB,mBAAmB,EAAE;;EAE7C,cAAc,mBAAmB,EAAE;;EAEnC,YAAY;;EAEZ;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,uBAAuB,gBAAgB,EAAE;;EAEzC,iBAAiB;;EAEjB,sBAAsB,mBAAmB,EAAE;;EAE3C;IACE,SAAS;IACT,eAAe;IACf,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA,+BAA+B,WAAW,EAAE;;EAE5C;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA,uBAAuB;;EAEvB,mBAAmB,aAAa,EAAE;;EAElC;IACE,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;IACpB,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,wBAAwB,WAAW,EAAE;;EAErC;IACE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA,YAAY;;EAEZ;IACE,SAAS;IACT,eAAe;IACf,aAAa;IACb,2BAA2B;EAC7B;;EAEA,gBAAgB,8BAA8B,EAAE;;;;EAIhD;;IAEE;;EAEF,iBAAiB,iBAAiB,EAAE;;EAEpC,0CAA0C,WAAW,EAAE;;EAEvD;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;;EAEA,gCAAgC,mBAAmB,EAAE;;;;EAIrD;;IAEE;;EAEF,iCAAiC,mBAAmB,EAAE;;EAEtD,mBAAmB,SAAS,EAAE;;EAE9B,gBAAgB,aAAa,EAAE;;;;EAI/B;;IAEE;;EAEF;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA,cAAc,kBAAkB,EAAE;;EAElC,sBAAsB,mBAAmB,EAAE;;EAE3C;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA,qBAAqB,eAAe,EAAE;;AAExC;;;;;;AAMA;;EAEE;;AAEF;;EAEE;;IAEE;;EAEF,oBAAoB,YAAY,EAAE;;EAElC,2CAA2C,YAAY,EAAE;;;;EAIzD;;IAEE;;EAEF;IACE,8BAA8B;IAC9B,cAAc;EAChB;;;;EAIA;;IAEE;;EAEF,eAAe,YAAY,EAAE;;;;EAI7B;;IAEE;;EAEF,uBAAuB;;EAEvB;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA,wBAAwB,WAAW,EAAE;;;;EAIrC;;IAEE;;EAEF,iBAAiB,oBAAoB,EAAE;;EAEvC,qBAAqB,aAAa,EAAE;;EAEpC;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA,4BAA4B,2BAA2B,EAAE;;EAEzD,6BAA6B,mCAAmC,EAAE;;EAElE,4BAA4B;;EAE5B,kCAAkC,8BAA8B,EAAE;;;;EAIlE;;IAEE;;EAEF,iBAAiB,8BAA8B,EAAE;;EAEjD;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;AAEF;;;;;;AAMA;;EAEE;;AAEF;;EAEE;;IAEE;;EAEF;;IAEE;;KAEC;;IAED,gDAAgD;IAChD,8CAA8C;IAC9C,8CAA8C;;EAEhD;;;;EAIA;;IAEE;;EAEF;IACE,YAAY;IACZ,2BAA2B;EAC7B;;;;EAIA;;IAEE;;EAEF,OAAO,mBAAmB,EAAE;;EAE5B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;;;EAIA;;IAEE;;EAEF;IACE,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA,eAAe,0BAA0B,EAAE;;;;EAI3C;;IAEE;;EAEF,YAAY;;EAEZ;IACE,8BAA8B;IAC9B,cAAc;EAChB;;EAEA,iBAAiB;;EAEjB,qBAAqB,2BAA2B,EAAE;;EAElD,YAAY;;EAEZ,gBAAgB,2BAA2B,EAAE;;;;EAI7C;;IAEE;;EAEF,gBAAgB,qCAAqC,EAAE;;;;EAIvD;;IAEE;;EAEF,mBAAmB,aAAa,EAAE;;AAEpC;;;;;;AAMA;;EAEE;;AAEF;;EAEE;;IAEE;;EAEF,0BAA0B,WAAW,EAAE;;EAEvC,gCAAgC,8BAA8B,EAAE;;EAEhE;IACE,oCAAoC;IACpC,kCAAkC;IAClC,mBAAmB;IACnB;yDACqD;EACvD;;EAEA,sCAAsC,mCAAmC,EAAE;;EAE3E,iCAAiC,YAAY,EAAE;;;;EAI/C;;IAEE;;EAEF,oBAAoB,WAAW,EAAE;;EAEjC,UAAU,gBAAgB,EAAE;;;;EAI5B;;IAEE;;EAEF;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,UAAU;IACV,SAAS;EACX;;;;EAIA;;IAEE;;EAEF;IACE,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA,gBAAgB,sBAAsB,EAAE;;EAExC,kBAAkB,YAAY,EAAE;;EAEhC;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,uBAAuB,YAAY,EAAE;;EAErC,iBAAiB,aAAa,EAAE;;EAEhC;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA,iBAAiB,0BAA0B,EAAE;;EAE7C;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA,eAAe,uBAAuB,EAAE;;;;EAIxC;;GAEC;;EAED,iBAAiB,gBAAgB,EAAE;;AAErC","sourcesContent":["\n/*-----------------------------------*\\\n  #RESET\n\\*-----------------------------------*/\n\n*, *::before, *::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\na { text-decoration: none; }\n\nli { list-style: none; }\n\nimg, ion-icon, a, button, time, span { display: block; }\n\nbutton {\n  font: inherit;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n}\n\ninput, textarea {\n  display: block;\n  width: 100%;\n  background: none;\n  font: inherit;\n}\n\n::selection {\n  background: var(--orange-yellow-crayola);\n  color: var(--smoky-black);\n}\n\n:focus { outline-color: var(--orange-yellow-crayola); }\n\nhtml { font-family: var(--ff-poppins); }\n\nbody { background: var(--smoky-black); }\n\n\n\n\n\n/*-----------------------------------*\\\n  #REUSED STYLE\n\\*-----------------------------------*/\n\n.sidebar,\narticle {\n  background: var(--eerie-black-2);\n  border: 1px solid var(--jet);\n  border-radius: 20px;\n  padding: 15px;\n  box-shadow: var(--shadow-1);\n  z-index: 1;\n}\n\n.separator {\n  width: 100%;\n  height: 1px;\n  background: var(--jet);\n  margin: 16px 0;\n}\n\n.icon-box {\n  position: relative;\n  background: var(--border-gradient-onyx);\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  color: var(--orange-yellow-crayola);\n  box-shadow: var(--shadow-1);\n  z-index: 1;\n}\n\n.icon-box::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  background: var(--eerie-black-1);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.icon-box ion-icon { --ionicon-stroke-width: 35px; }\n\n\narticle.active {\n  display: block;\n  animation: fade 0.5s ease backwards;\n}\n\n@keyframes fade {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n.h2,\n.h3,\n.h4,\n.h5 {\n  color: var(--white-2);\n  text-transform: capitalize;\n}\n\n.h2 { font-size: var(--fs-1); }\n\n.h3 { font-size: var(--fs-2); }\n\n.h4 { font-size: var(--fs-4); }\n\n.h5 {\n  font-size: var(--fs-7);\n  font-weight: var(--fw-500);\n}\n\n.article-title {\n  position: relative;\n  padding-bottom: 7px;\n}\n\n.article-title::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 30px;\n  height: 3px;\n  background: var(--text-gradient-yellow);\n  border-radius: 3px;\n}\n\n.has-scrollbar::-webkit-scrollbar {\n  width: 5px; /* for vertical scrollbar */\n  height: 5px; /* for horizontal scrollbar */\n}\n\n.has-scrollbar::-webkit-scrollbar-track {\n  background: var(--onyx);\n  border-radius: 5px;\n}\n\n.has-scrollbar::-webkit-scrollbar-thumb {\n  background: var(--orange-yellow-crayola);\n  border-radius: 5px;\n}\n\n.has-scrollbar::-webkit-scrollbar-button { width: 20px; }\n\n.content-card {\n  position: relative;\n  background: var(--border-gradient-onyx);\n  padding: 15px;\n  padding-top: 45px;\n  border-radius: 14px;\n  box-shadow: var(--shadow-2);\n  cursor: pointer;\n  z-index: 1;\n}\n\n.content-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  background: var(--bg-gradient-jet);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n\n\n\n\n/*-----------------------------------*\\\n  #MAIN\n\\*-----------------------------------*/\n\nmain {\n  margin: 15px 12px;\n  margin-bottom: 75px;\n  min-width: 259px;\n}\n\n\n\n\n\n/*-----------------------------------*\\\n  #SIDEBAR\n\\*-----------------------------------*/\n\n.sidebar {\n  margin-bottom: 15px;\n  max-height: 112px;\n  overflow: hidden;\n  transition: var(--transition-2);\n}\n\n.sidebar.active { max-height: 405px; }\n\n.sidebar-info {\n  position: relative;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 15px;\n}\n\n.avatar-box {\n  background: var(--bg-gradient-onyx);\n  border-radius: 20px;\n}\n\n.info-content .name {\n  color: var(--white-2);\n  font-size: var(--fs-3);\n  font-weight: var(--fw-500);\n  letter-spacing: -0.25px;\n  margin-bottom: 10px;\n}\n\n.info-content .title {\n  color: var(--white-1);\n  background: var(--onyx);\n  font-size: var(--fs-8);\n  font-weight: var(--fw-300);\n  width: max-content;\n  padding: 3px 12px;\n  border-radius: 8px;\n}\n\n.info_more-btn {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  border-radius: 0 15px;\n  font-size: 13px;\n  color: var(--orange-yellow-crayola);\n  background: var(--border-gradient-onyx);\n  padding: 10px;\n  box-shadow: var(--shadow-2);\n  transition: var(--transition-1);\n  z-index: 1;\n}\n\n.info_more-btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  border-radius: inherit;\n  background: var(--bg-gradient-jet);\n  transition: var(--transition-1);\n  z-index: -1;\n}\n\n.info_more-btn:hover,\n.info_more-btn:focus { background: var(--bg-gradient-yellow-1); }\n\n.info_more-btn:hover::before,\n.info_more-btn:focus::before { background: var(--bg-gradient-yellow-2); }\n\n.info_more-btn span { display: none; }\n\n.sidebar-info_more {\n  opacity: 0;\n  visibility: hidden;\n  transition: var(--transition-2);\n}\n\n.sidebar.active .sidebar-info_more {\n  opacity: 1;\n  visibility: visible;\n}\n\n.contacts-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n.contact-item {\n  min-width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.contact-info {\n  max-width: calc(100% - 46px);\n  width: calc(100% - 46px);\n}\n\n.contact-title {\n  color: var(--light-gray-70);\n  font-size: var(--fs-8);\n  text-transform: uppercase;\n  margin-bottom: 2px;\n}\n\n.contact-info :is(.contact-link, time, address) {\n  color: var(--white-2);\n  font-size: var(--fs-7);\n}\n\n.contact-info address { font-style: normal; }\n\n.social-list {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 15px;\n  padding-bottom: 4px;\n  padding-left: 7px;\n}\n\n.social-item .social-link {\n  color: var(--light-gray-70);\n  font-size: 18px;\n}\n\n\n.social-item .social-link:hover { color: var(--light-gray); }\n\n\n\n\n\n/*-----------------------------------*\\\n  #NAVBAR\n\\*-----------------------------------*/\n\n.navbar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: hsla(240, 1%, 17%, 0.75);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--jet);\n  border-radius: 12px 12px 0 0;\n  box-shadow: var(--shadow-2);\n  z-index: 5;\n}\n\n.navbar-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.navbar-link {\n  color: var(--light-gray);\n  font-size: var(--fs-8);\n  padding: 20px 7px;\n  transition: color var(--transition-1);\n}\n\n.navbar-link:hover,\n.navbar-link:focus { color: var(--light-gray-70); }\n\n.navbar-link.active { color: var(--orange-yellow-crayola); }\n\n\n\n\n\n/*-----------------------------------*\\\n  #ABOUT\n\\*-----------------------------------*/\n\n.about .article-title { margin-bottom: 15px; }\n\n.about-text {\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n  line-height: 1.6;\n}\n\n.about-text p { margin-bottom: 15px; }\n\n\n\n/**\n * #service \n */\n\n.service { margin-bottom: 35px; }\n\n.service-title { margin-bottom: 20px; }\n\n.service-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n.service-item {\n  position: relative;\n  background: var(--border-gradient-onyx);\n  padding: 20px;\n  border-radius: 14px;\n  box-shadow: var(--shadow-2);\n  z-index: 1;\n}\n\n.service-item::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  background: var(--bg-gradient-jet);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.service-icon-box { margin-bottom: 10px; }\n\n.service-icon-box img { margin: auto; }\n\n.service-content-box { text-align: center; }\n\n.service-item-title { margin-bottom: 7px; }\n\n.service-item-text {\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-3);\n  line-height: 1.6;\n}\n\n\n/**\n * #testimonials \n */\n\n.testimonials { margin-bottom: 30px; }\n\n.testimonials-title { margin-bottom: 20px; }\n\n.testimonials-list {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 15px;\n  margin: 0 -15px;\n  padding: 25px 15px;\n  padding-bottom: 35px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  overscroll-behavior-inline: contain;\n  scroll-snap-type: inline mandatory;\n}\n\n.testimonials-item {\n  min-width: 100%;\n  scroll-snap-align: center;\n}\n\n.testimonials-avatar-box {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(15px, -25px);\n  background: var(--bg-gradient-onyx);\n  border-radius: 14px;\n  box-shadow: var(--shadow-1);\n}\n\n.testimonials-item-title { margin-bottom: 7px; }\n\n.testimonials-text {\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n  line-height: 1.6;\n  display: -webkit-box;\n  line-clamp: 4;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n\n/**\n * #testimonials-modal\n */\n\n.modal-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  z-index: 20;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.modal-container::-webkit-scrollbar { display: none; }\n\n.modal-container.active {\n  pointer-events: all;\n  visibility: visible;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: hsl(0, 0%, 5%);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  z-index: 1;\n  transition: var(--transition-1);\n}\n\n.overlay.active {\n  opacity: 0.8;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.testimonials-modal {\n  background: var(--eerie-black-2);\n  position: relative;\n  padding: 15px;\n  margin: 15px 12px;\n  border: 1px solid var(--jet);\n  border-radius: 14px;\n  box-shadow: var(--shadow-5);\n  transform: scale(1.2);\n  opacity: 0;\n  transition: var(--transition-1);\n  z-index: 2;\n}\n\n.modal-container.active .testimonials-modal {\n  transform: scale(1);\n  opacity: 1;\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: var(--onyx);\n  border-radius: 8px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--white-2);\n  font-size: 18px;\n  opacity: 0.7;\n}\n\n.modal-close-btn:hover,\n.modal-close-btn:focus { opacity: 1; }\n\n.modal-close-btn ion-icon { --ionicon-stroke-width: 50px; }\n\n.modal-avatar-box {\n  background: var(--bg-gradient-onyx);\n  width: max-content;\n  border-radius: 14px;\n  margin-bottom: 15px;\n  box-shadow: var(--shadow-2);\n}\n\n.modal-img-wrapper > img { display: none; }\n\n.modal-title { margin-bottom: 4px; }\n\n.modal-content time {\n  font-size: var(--fs-6);\n  color: var(--light-gray-70);\n  font-weight: var(--fw-300);\n  margin-bottom: 10px;\n}\n\n.modal-content p {\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n  line-height: 1.6;\n}\n\n\n/**\n * #clients \n */\n\n.clients { margin-bottom: 15px; }\n\n.clients-list {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 15px;\n  margin: 0 -15px;\n  padding: 25px;\n  padding-bottom: 25px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  overscroll-behavior-inline: contain;\n  scroll-snap-type: inline mandatory;\n  scroll-padding-inline: 25px;\n}\n\n.clients-item {\n  min-width: 50%;\n  scroll-snap-align: start;\n}\n\n.clients-item img {\n  width: 100%;\n  filter: grayscale(1);\n  transition: var(--transition-1);\n}\n\n.clients-item img:hover { filter: grayscale(0); }\n\n\n\n\n\n/*-----------------------------------*\\\n  #RESUME\n\\*-----------------------------------*/\n\n.article-title { margin-bottom: 30px; }\n\n\n/**\n * education and experience \n */\n\n.timeline { margin-bottom: 30px; }\n\n.timeline .title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 25px;\n}\n\n.timeline-list {\n  font-size: var(--fs-6);\n  margin-left: 45px;\n}\n\n.timeline-item { position: relative; }\n\n.timeline-item:not(:last-child) { margin-bottom: 20px; }\n\n.timeline-item-title {\n  font-size: var(--fs-6);\n  line-height: 1.3;\n  margin-bottom: 7px;\n}\n\n.timeline-list span {\n  color: var(--vegas-gold);\n  font-weight: var(--fw-400);\n  line-height: 1.6;\n}\n\n.timeline-item:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  top: -25px;\n  left: -30px;\n  width: 1px;\n  height: calc(100% + 50px);\n  background: var(--jet);\n}\n\n.timeline-item::after {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  left: -33px;\n  height: 6px;\n  width: 6px;\n  background: var(--text-gradient-yellow);\n  border-radius: 50%;\n  box-shadow: 0 0 0 4px var(--jet);\n}\n\n.timeline-text {\n  color: var(--light-gray);\n  font-weight: var(--fw-300);\n  line-height: 1.6;\n}\n\n\n/**\n * skills \n */\n\n.skills-title { margin-bottom: 20px; }\n\n.skills-list { padding: 20px; }\n\n\n.skills-item:not(:last-child) { margin-bottom: 15px; }\n\n.skill .title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\n.skill .title-wrapper data {\n  color: var(--light-gray);\n  font-size: var(--fs-7);\n  font-weight: var(--fw-300);\n}\n\n.skill-progress-bg {\n  background: var(--jet);\n  width: 100%;\n  height: 8px;\n  border-radius: 10px;\n}\n\n.skill-progress-fill {\n  background: var(--text-gradient-yellow);\n  height: 100%;\n  border-radius: inherit;\n}\n\n\n\n\n\n/*-----------------------------------*\\\n  #PORTFOLIO\n\\*-----------------------------------*/\n\n.filter-list { display: none; }\n\n.filter-select-box {\n  position: relative;\n  margin-bottom: 25px;\n}\n\n.filter-select {\n  background: var(--eerie-black-2);\n  color: var(--light-gray);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--jet);\n  border-radius: 14px;\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n}\n\n.filter-select.active .select-icon { transform: rotate(0.5turn); }\n\n.select-list {\n  background: var(--eerie-black-2);\n  position: absolute;\n  top: calc(100% + 6px);\n  width: 100%;\n  padding: 6px;\n  border: 1px solid var(--jet);\n  border-radius: 14px;\n  z-index: 2;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: 0.15s ease-in-out;\n}\n\n.filter-select.active + .select-list {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.select-item button {\n  background: var(--eerie-black-2);\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n  text-transform: capitalize;\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.select-item button:hover { --eerie-black-2: hsl(240, 2%, 20%); }\n\n.project-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 30px;\n  margin-bottom: 10px;\n}\n\n.project-item { display: none; }\n\n.project-item.active {\n  display: block;\n  animation: scaleUp 0.25s ease forwards;\n}\n\n@keyframes scaleUp {\n  0% { transform: scale(0.5); }\n  100% { transform: scale(1); }\n}\n\n.project-item > a { width: 100%; }\n\n.project-img {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 15px;\n}\n\n.project-img::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  z-index: 1;\n  transition: var(--transition-1);\n}\n\n.project-item > a:hover .project-img::before { background: hsla(0, 0%, 0%, 0.5); }\n\n.project-item-icon-box {\n  --scale: 0.8;\n\n  background: var(--jet);\n  color: var(--orange-yellow-crayola);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(var(--scale));\n  font-size: 20px;\n  padding: 18px;\n  border-radius: 12px;\n  opacity: 0;\n  z-index: 1;\n  transition: var(--transition-1);\n}\n\n.project-item > a:hover .project-item-icon-box {\n  --scale: 1;\n  opacity: 1;\n}\n\n.project-item-icon-box ion-icon { --ionicon-stroke-width: 50px; }\n\n.project-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: var(--transition-1);\n}\n\n.project-item > a:hover img { transform: scale(1.1); }\n\n.project-title,\n.project-category { margin-left: 10px; }\n\n.project-title {\n  color: var(--white-2);\n  font-size: var(--fs-5);\n  font-weight: var(--fw-400);\n  text-transform: capitalize;\n  line-height: 1.3;\n}\n\n.project-category {\n  color: var(--light-gray-70);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n}\n\n\n\n\n\n/*-----------------------------------*\\\n  #BLOG\n\\*-----------------------------------*/\n\n.blog-posts { margin-bottom: 10px; }\n\n.blog-posts-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n.blog-post-item > a {\n  position: relative;\n  background: var(--border-gradient-onyx);\n  height: 100%;\n  box-shadow: var(--shadow-4);\n  border-radius: 16px;\n  z-index: 1;\n}\n\n.blog-post-item > a::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  border-radius: inherit;\n  background: var(--eerie-black-1);\n  z-index: -1;\n}\n\n.blog-banner-box {\n  width: 100%;\n  height: 200px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.blog-banner-box img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: var(--transition-1);\n}\n\n.blog-post-item > a:hover .blog-banner-box img { transform: scale(1.1); }\n\n.blog-content { padding: 15px; }\n\n.blog-meta {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 10px;\n}\n\n.blog-meta :is(.blog-category, time) {\n  color: var(--light-gray-70);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n}\n\n.blog-meta .dot {\n  background: var(--light-gray-70);\n  width: 4px;\n  height: 4px;\n  border-radius: 4px;\n}\n\n.blog-item-title {\n  margin-bottom: 10px;\n  line-height: 1.3;\n  transition: var(--transition-1);\n}\n\n.blog-post-item > a:hover .blog-item-title { color: var(--orange-yellow-crayola); }\n\n.blog-text {\n  color: var(--light-gray);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-300);\n  line-height: 1.6;\n}\n\n\n\n\n\n/*-----------------------------------*\\\n  #CONTACT\n\\*-----------------------------------*/\n\n.mapbox {\n  position: relative;\n  height: 250px;\n  width: 100%;\n  border-radius: 16px;\n  margin-bottom: 30px;\n  border: 1px solid var(--jet);\n  overflow: hidden;\n}\n\n.mapbox figure { height: 100%; }\n\n.mapbox iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  filter: grayscale(1) invert(1);\n}\n\n.contact-form { margin-bottom: 10px; }\n\n.form-title { margin-bottom: 20px; }\n\n.input-wrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 25px;\n  margin-bottom: 25px;\n}\n\n.form-input {\n  color: var(--white-2);\n  font-size: var(--fs-6);\n  font-weight: var(--fw-400);\n  padding: 13px 20px;\n  border: 1px solid var(--jet);\n  border-radius: 14px;\n  outline: none;\n}\n\n.form-input::placeholder { font-weight: var(--fw-500); }\n\n.form-input:focus { border-color: var(--orange-yellow-crayola); }\n\ntextarea.form-input {\n  min-height: 100px;\n  height: 120px;\n  max-height: 200px;\n  resize: vertical;\n  margin-bottom: 25px;\n}\n\ntextarea.form-input::-webkit-resizer { display: none; }\n\n.form-input:focus:invalid { border-color: var(--bittersweet-shimmer); }\n\n.form-btn {\n  position: relative;\n  width: 100%;\n  background: var(--border-gradient-onyx);\n  color: var(--orange-yellow-crayola);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 20px;\n  border-radius: 14px;\n  font-size: var(--fs-6);\n  text-transform: capitalize;\n  box-shadow: var(--shadow-3);\n  z-index: 1;\n  transition: var(--transition-1);\n}\n\n.form-btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  background: var(--bg-gradient-jet);\n  border-radius: inherit;\n  z-index: -1;\n  transition: var(--transition-1);\n}\n\n.form-btn ion-icon { font-size: 16px; }\n\n.form-btn:hover { background: var(--bg-gradient-yellow-1); }\n\n.form-btn:hover::before { background: var(--bg-gradient-yellow-2); }\n\n.form-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.form-btn:disabled:hover { background: var(--border-gradient-onyx); }\n\n.form-btn:disabled:hover::before { background: var(--bg-gradient-jet); }\n\n\n\n\n\n/*-----------------------------------*\\\n  #RESPONSIVE\n\\*-----------------------------------*/\n\n/**\n * responsive larger than 450px screen\n */\n\n@media (min-width: 450px) {\n\n  /**\n   * client\n   */\n\n  .clients-item { min-width: calc(33.33% - 10px); }\n\n\n\n  /**\n   * #PORTFOLIO, BLOG \n   */\n\n  .project-img,\n  .blog-banner-box { height: auto; }\n\n}\n\n\n\n\n\n/**\n * responsive larger than 580px screen\n */\n\n@media (min-width: 580px) {\n\n  /**\n   * CUSTOM PROPERTY\n   */\n\n  :root {\n\n    /**\n     * typography\n     */\n\n    --fs-1: 32px;\n    --fs-2: 24px;\n    --fs-3: 26px;\n    --fs-4: 18px;\n    --fs-6: 15px;\n    --fs-7: 15px;\n    --fs-8: 12px;\n\n  }\n\n\n\n  /**\n   * #REUSED STYLE\n   */\n\n  .sidebar, article {\n    width: 520px;\n    margin-inline: auto;\n    padding: 30px;\n  }\n\n  .article-title {\n    font-weight: var(--fw-600);\n    padding-bottom: 15px;\n  }\n\n  .article-title::after {\n    width: 40px;\n    height: 5px;\n  }\n\n  .icon-box {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    font-size: 18px;\n  }\n\n\n\n  /**\n   * #MAIN\n   */\n\n  main {\n    margin-top: 60px;\n    margin-bottom: 100px;\n  }\n\n\n\n  /**\n   * #SIDEBAR\n   */\n\n  .sidebar {\n    max-height: 180px;\n    margin-bottom: 30px;\n  }\n\n  .sidebar.active { max-height: 584px; }\n\n  .sidebar-info { gap: 25px; }\n\n  .avatar-box { border-radius: 30px; }\n\n  .avatar-box img { width: 120px; }\n\n  .info-content .name { margin-bottom: 15px; }\n\n  .info-content .title { padding: 5px 18px; }\n\n  .info_more-btn {\n    top: -30px;\n    right: -30px;\n    padding: 10px 15px;\n  }\n\n  .info_more-btn span {\n    display: block;\n    font-size: var(--fs-8);\n  }\n\n  .info_more-btn ion-icon { display: none; }\n\n  .separator { margin: 32px 0; }\n\n  .contacts-list { gap: 20px; }\n\n  .contact-info {\n    max-width: calc(100% - 64px);\n    width: calc(100% - 64px);\n  }\n\n\n\n  /**\n   * #NAVBAR\n   */\n\n  .navbar { border-radius: 20px 20px 0 0; }\n\n  .navbar-list { gap: 20px; }\n\n  .navbar-link { --fs-8: 14px; }\n\n\n\n  /**\n   * #ABOUT\n   */\n\n  .about .article-title { margin-bottom: 20px; }\n\n  .about-text { margin-bottom: 40px; }\n\n  /* service */\n\n  .service-item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 18px;\n    padding: 30px;\n  }\n\n  .service-icon-box {\n    margin-bottom: 0;\n    margin-top: 5px;\n  }\n\n  .service-content-box { text-align: left; }\n\n  /* testimonials */\n\n  .testimonials-title { margin-bottom: 25px; }\n\n  .testimonials-list {\n    gap: 30px;\n    margin: 0 -30px;\n    padding: 30px;\n    padding-bottom: 35px;\n  }\n\n  .content-card {\n    padding: 30px;\n    padding-top: 25px;\n  }\n\n  .testimonials-avatar-box {\n    transform: translate(30px, -30px);\n    border-radius: 20px;\n  }\n\n  .testimonials-avatar-box img { width: 80px; }\n\n  .testimonials-item-title {\n    margin-bottom: 10px;\n    margin-left: 95px;\n  }\n\n  .testimonials-text {\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n  }\n\n  /* testimonials modal */\n\n  .modal-container { padding: 20px; }\n\n  .testimonials-modal {\n    display: flex;\n    justify-content: flex-start;\n    align-items: stretch;\n    gap: 25px;\n    padding: 30px;\n    border-radius: 20px;\n  }\n\n  .modal-img-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .modal-avatar-box {\n    border-radius: 18px;\n    margin-bottom: 0;\n  }\n\n  .modal-avatar-box img { width: 65px; }\n\n  .modal-img-wrapper > img {\n    display: block;\n    flex-grow: 1;\n    width: 35px;\n  }\n\n  /* clients */\n\n  .clients-list {\n    gap: 50px;\n    margin: 0 -30px;\n    padding: 45px;\n    scroll-padding-inline: 45px;\n  }\n\n  .clients-item { min-width: calc(33.33% - 35px); }\n\n\n\n  /**\n   * #RESUME\n   */\n\n  .timeline-list { margin-left: 65px; }\n\n  .timeline-item:not(:last-child)::before { left: -40px; }\n\n  .timeline-item::after {\n    height: 8px;\n    width: 8px;\n    left: -43px;\n  }\n\n  .skills-item:not(:last-child) { margin-bottom: 25px; }\n\n\n\n  /**\n   * #PORTFOLIO, BLOG\n   */\n\n  .project-img, .blog-banner-box { border-radius: 16px; }\n\n  .blog-posts-list { gap: 30px; }\n\n  .blog-content { padding: 25px; }\n\n\n\n  /**\n   * #CONTACT\n   */\n\n  .mapbox {\n    height: 380px;\n    border-radius: 18px;\n  }\n\n  .input-wrapper {\n    gap: 30px;\n    margin-bottom: 30px;\n  }\n\n  .form-input { padding: 15px 20px; }\n\n  textarea.form-input { margin-bottom: 30px; }\n\n  .form-btn {\n    --fs-6: 16px;\n    padding: 16px 20px;\n  }\n\n  .form-btn ion-icon { font-size: 18px; }\n\n}\n\n\n\n\n\n/**\n * responsive larger than 768px screen\n */\n\n@media (min-width: 768px) {\n\n  /**\n   * REUSED STYLE\n   */\n\n  .sidebar, article { width: 700px; }\n\n  .has-scrollbar::-webkit-scrollbar-button { width: 100px; }\n\n\n\n  /**\n   * SIDEBAR\n   */\n\n  .contacts-list {\n    grid-template-columns: 1fr 1fr;\n    gap: 30px 15px;\n  }\n\n\n\n  /**\n   * NAVBAR\n   */\n\n  .navbar-link { --fs-8: 15px; }\n\n\n\n  /**\n   * ABOUT\n   */\n\n  /* testimonials modal */\n\n  .testimonials-modal {\n    gap: 35px;\n    max-width: 680px;\n  }\n\n  .modal-avatar-box img { width: 80px; }\n\n\n\n  /**\n   * PORTFOLIO\n   */\n\n  .article-title { padding-bottom: 20px; }\n\n  .filter-select-box { display: none; }\n\n  .filter-list {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 25px;\n    padding-left: 5px;\n    margin-bottom: 30px;\n  }\n\n  .filter-item button {\n    color: var(--light-gray);\n    font-size: var(--fs-5);\n    transition: var(--transition-1);\n  }\n\n  .filter-item button:hover { color: var(--light-gray-70); }\n\n  .filter-item button.active { color: var(--orange-yellow-crayola); }\n\n  /* portfolio and blog grid */\n\n  .project-list, .blog-posts-list { grid-template-columns: 1fr 1fr; }\n\n\n\n  /**\n   * CONTACT\n   */\n\n  .input-wrapper { grid-template-columns: 1fr 1fr; }\n\n  .form-btn {\n    width: max-content;\n    margin-left: auto;\n  }\n  \n}\n\n\n\n\n\n/**\n * responsive larger than 1024px screen\n */\n\n@media (min-width: 1024px) {\n\n  /**\n   * CUSTOM PROPERTY\n   */\n\n  :root {\n\n    /**\n    * shadow\n    */\n\n    --shadow-1: -4px 8px 24px hsla(0, 0%, 0%, 0.125);\n    --shadow-2: 0 16px 30px hsla(0, 0%, 0%, 0.125);\n    --shadow-3: 0 16px 40px hsla(0, 0%, 0%, 0.125);\n\n  }\n\n\n\n  /**\n   * REUSED STYLE\n   */\n\n  .sidebar, article {\n    width: 950px;\n    box-shadow: var(--shadow-5);\n  }\n\n\n\n  /**\n   * MAIN \n   */\n\n  main { margin-bottom: 60px; }\n\n  .main-content {\n    position: relative;\n    width: max-content;\n    margin: auto;\n  }\n\n\n\n  /**\n   * NAVBAR\n   */\n\n  .navbar {\n    position: absolute;\n    bottom: auto;\n    top: 0;\n    left: auto;\n    right: 0;\n    width: max-content;\n    border-radius: 0 20px;\n    padding: 0 20px;\n    box-shadow: none;\n  }\n\n  .navbar-list {\n    gap: 30px;\n    padding: 0 20px;\n  }\n\n  .navbar-link { font-weight: var(--fw-500); }\n\n\n\n  /**\n   * ABOUT\n   */\n\n  /* service */\n\n  .service-list {\n    grid-template-columns: 1fr 1fr;\n    gap: 20px 25px;\n  }\n\n  /* testimonials */\n\n  .testimonials-item { min-width: calc(50% - 15px); }\n\n  /* clients */\n\n  .clients-item { min-width: calc(25% - 38px); }\n\n\n\n  /**\n   * PORTFOLIO\n   */\n\n  .project-list { grid-template-columns: repeat(3, 1fr); }\n\n\n\n  /**\n   * BLOG\n   */\n\n  .blog-banner-box { height: 230px; }\n\n}\n\n\n\n\n\n/**\n * responsive larger than 1250px screen\n */\n\n@media (min-width: 1250px) {\n\n  /**\n   * RESET\n   */\n\n  body::-webkit-scrollbar { width: 20px; }\n\n  body::-webkit-scrollbar-track { background: var(--smoky-black); }\n\n  body::-webkit-scrollbar-thumb {\n    border: 5px solid var(--smoky-black);\n    background: hsla(0, 0%, 100%, 0.1);\n    border-radius: 20px;\n    box-shadow: inset 1px 1px 0 hsla(0, 0%, 100%, 0.11),\n                inset -1px -1px 0 hsla(0, 0%, 100%, 0.11);\n  }\n\n  body::-webkit-scrollbar-thumb:hover { background: hsla(0, 0%, 100%, 0.15); }\n\n  body::-webkit-scrollbar-button { height: 60px; }\n\n\n\n  /**\n   * REUSED STYLE\n   */\n\n  .sidebar, article { width: auto; }\n\n  article { min-height: 100%; }\n\n\n\n  /**\n   * MAIN\n   */\n\n  main {\n    max-width: 1200px;\n    margin-inline: auto;\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    gap: 25px;\n  }\n\n  .main-content {\n    min-width: 75%;\n    width: 75%;\n    margin: 0;\n  }\n\n\n\n  /**\n   * SIDEBAR\n   */\n\n  .sidebar {\n    position: sticky;\n    top: 60px;\n    max-height: max-content;\n    height: 100%;\n    margin-bottom: 0;\n    padding-top: 60px;\n    z-index: 1;\n  }\n\n  .sidebar-info { flex-direction: column; }\n\n  .avatar-box img { width: 150px; }\n\n  .info-content .name {\n    white-space: nowrap;\n    text-align: center;\n  }\n\n  .info-content .title { margin: auto; }\n\n  .info_more-btn { display: none; }\n\n  .sidebar-info_more {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .contacts-list { grid-template-columns: 1fr; }\n\n  .contact-info :is(.contact-link) {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .contact-info :is(.contact-link, time, address) {\n    --fs-7: 14px;\n    font-weight: var(--fw-300);\n  }\n\n  .separator:last-of-type {\n    margin: 15px 0;\n    opacity: 0;\n  }\n\n  .social-list { justify-content: center; }\n\n\n\n  /**\n\t * RESUME\n\t */\n\n  .timeline-text { max-width: 700px; }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
